
/* injects from baggage-loader */

'use strict';

import { omit } from 'lodash';

export default class CreateProductVariantModalController {

	constructor($log, Product) {
		'ngInject';

		this.$log = $log;
		this.Product = Product;
		this.serialNumber = '';

	}

	$onInit() {
		this.product = this.resolve.context.product;
	}

	async save() {

		this.cloningProduct = true;

		try {

			let clonedProduct = omit(this.product.toJSON(), [
				'objectId',
				'createdAt',
				'updatedAt',
				'ACL',
				'stats',
				'documents',
				'fieldLog'
			]);
			
			let variant = new this.Product();

			await variant.save(Object.assign(clonedProduct, {
				serial_number: this.serialNumber,
				parent: this.product
			}));

			this.close({
				$value: {
					productVariant: variant
				}
			});

		} catch (err) {
			this.error_msg = err;
			this.cloningProduct = false;
		}

	}

	cancel() {
		this.dismiss({ $value: 'cancel' });
	}

}



// WEBPACK FOOTER //
// ./src/app/components/createProductVariantModal/createProductVariantModal.controller.js